import {HttpContextToken, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { LoaderService } from "@shared/index";
import { finalize } from "rxjs";

export const SHOW_LOADER=new HttpContextToken<boolean>(()=> true);

export const loaderInterceptor:HttpInterceptorFn=(req,next)=>{
    const loaderService=inject(LoaderService);
    console.log("loader interceptor");
    
    if(req.context.get(SHOW_LOADER)== false){
        return next(req);
    }
    loaderService.show();
    return next(req).pipe(
       finalize(()=> loaderService.hide()) 
    )
}